/** @jsxImportSource @emotion/react */
import { Button, DialogActions, DialogContent, Divider, FormControl, FormHelperText, Grid, Snackbar, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useContext, useState } from 'react';
import ElevatedGrid from '../../Components/ElevatedGrid';
import { Il8nContext } from '../../Helper/i18n';
import PageLayout from '../Layout/PageLayout';
import { useEffect } from 'react';
import { StyledTextField } from '../../Components/CustomTextfield';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { steps } from '../../Helper/AppStepperData';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import getCookie, { getToken } from '../../Helper/Cookies/cookies';
import Popup, { PopupTitle } from '../../Components/CustomPopup';
import UploadIcon from '../../Components/DocumentUpload/UploadIcon';
import DialogForUpload from "../../Components/DocumentUpload/DialogForUpload"
import UploadDialog from "../../Components/DocumentUpload/UploadDialog"
import UploadPdf from "../../Components/DocumentUpload/UploadPdf"
import ProofDialog from "../../Components/DocumentUpload/ProofDialog"
import FullScreenLoader from '../../Components/FullScreenLoader';
// import UploadVideo from '../../Components/Upload/UploadVideo/UploadVideo';
import { updateStepper } from '../../Helper/Redux/reducers/upDown';
import { getObjections, objectionNavigation, setObjections } from '../../Helper/Functions';
import Upload from '../../Components/Upload';
import PhotoProofDialog from '../../Components/DocumentUpload/PhotoProofDialog';
var inprdocument;

let value=[]
function Uploads(props) {
    const theme = useTheme();
    const store = useSelector(state => state.storeState.stage)
    const stepper = useSelector(state => state.storeState.stepper)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [responseStatus, setResponseStatus] = useState({})
    const [documentData, setDocumentData] = useState([])
    const [documentInPrData, setDocumentInPrData] = useState([])
    const [id, setId] = useState();
    const [loading, setLoading] = useState(false);
    const [geoLocationData, setGeoLocationData] = useState({})
    const [objectionState, setObjectionState] = useState({ "isObjection": false, "objections": [] })
    const [ocrUploadLoading,setOcrUploadLoading] = useState(false)
    const [documentsUploadedDetails, setDocumentsUploadedDetails] = useState([])
    const [openInnerDialog, setOpenInnerDialog] = useState(false);
    const [documentTypeOption, setDocumentTypeOption] = useState();
    const [documentUploadedFor, setDocumentUploadedFor] = useState();
    const [showUploadPopup, setUploadPopup] = useState(false);
    const [image, setImage] = useState();
    const [pdf, setPdf] = useState();
    const [showPdfPopup, setPdfPopup] = useState(false);
    const [docMId, setDocMId] = useState()
    const [numberOfImages, setNumberOfImages] = useState(1)
    const [documentName, setDocumentName] = useState("");
    const [documentMappingKey, setDocumentMappingKey] = useState("");
    const [documentMasterId, setDocumentMasterId] = useState()
    const [openIPVPopup, setOpenIPVPopup] = useState(false)
    const [openPhotographPopup, setOpenPhotographPopup] = useState(false)
    const [uploadedDocuments, setUploadedDocuments] = useState([]);
    const [UploadedInPrData, setUploadedInPrData] = useState([]);
    const [lat,setLat]=useState()
    const [long,setLong]=useState()
    const [showUpload, setShowUpload]=useState(false)
    const [segmentOptions, setSegmentOptions] = useState([])
    const [segmentsSelected, setSegmentsSelected] = useState([])
    const [indexValue, setIndexValue] = useState(0)
    const [ipvPhoto, setIpvPhoto] = useState(null)
    const localeText = useContext(Il8nContext)
    const [stageDetailsResp, setStageDetailsResp] = useState()


    const documentTypePerName = {
        "CPOA": "Corresponding Address",
        "PPOA": "Permanent Address",
        "POA": "Power of Attorney",
        "POI": "Proof Of Identity",
        "Sign": "Signature",
        "Photo": "Photograph Dialog",
        "KYCP": "KYC Proof",
        "DePr": "Demat Proof",
        "BaPr": "Bank Proof",
        "InPr": "Income Proof",
        "Nom": "Nominee Proof",
        "Gurd": "Guardian Proof",
        "IPV": "In-Person Verification",
        "KRA": "KYC KRA Page",
        "default": "Document Upload",
        "BalSh": "Copy of Balance sheet of past two years",
        "AuSig": "Authorised Signatory on letter head of Firm/Company",
        "ITR": "IT Return for last 2 financial years",
        "PDeed": "Partnership  deed",
        "PCapR": "Partnership capital ratio",
        "DMapL": "Demat account Mapping Letter",
        "MOA": "MOA and AOA of the company",
        "Annx": "Annexure page",
        "BoRes": "Board Resolution",
        "NetWo": "Net Worth Certificate",
        "RCert": "Registration Certificate",
        "Oth": "Others",
    }

    const documentICONS = {
        "CPOA": "/images/Address Proof.svg",
        "PPOA": "/images/Address Proof.svg",
        "POI": "/images/Photo ID Proof.svg",
        "Sign": "/images/Signature.svg",
        "Photo": "/images/Photo.svg",
        "BaPr": "/images/Bank-Proof.svg",
        "IPV": "/images/IPV (Video Recording).svg",
        "Oth": "/images/Other.svg"
    }

    useEffect(() => {
        getStageDetails()
        getSegments()
        !(stepper?.length) && dispatch(updateStepper({ setDirectly : true, stepper : [1, 3, 3] }))
        let objectionValue = getObjections()
        let objections = objectionValue?.filter(objection => objection.navigationPath == "/Upload")

        if (objections?.length > 0) {
            objections = objections.map(objection => {
                return {
                    "objectionDescription": objection.objectionDescription,
                    "remark": objection.remark
                }
            })

            objectionValue = objectionValue.map(objection => {
                if (objection.navigationPath == "/Upload") {
                    objection.isNavigationDone = true;
                }
                return objection
            })

            setObjections(objectionValue)
            setObjectionState({ isObjection: true, objections })
        }
    }, [])

    useEffect(()=>{
        if(documentData?.length > 0){
            allDocumentUpdated()
        }
    },[documentData, documentInPrData])

    useEffect(() => {
        displayData()
    }, [value])

    useEffect(()=>{
        getDocuments()
    },[segmentOptions])

    useEffect(()=>{
        allDocumentUpdated()
    },[segmentsSelected, UploadedInPrData])

    const getSegments = () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.segments)
            .then(resp => {
                if (resp.data.success) {
                    setSegmentOptions(resp.data.success.segments)
                    getSegmentsSelected()
                    setLoading(false)
                }
                else {
                    setLoading(false)
                    throw new Error(resp.data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                console.log(err.message)
            })
    }

    const getStageDetails = () => {
        axios.get(process.env.REACT_APP_API_URL + config.stageDetails)
            .then(resp => {
                if (resp.data.success) {
                    setStageDetailsResp(resp.data.success);
                } else {
                    throw new Error()
                }
            }).catch((err) => {
                console.log(err.message)
            })
    }

    const getSegmentsSelected = () =>{
        let payload = {}
        axios.post(process.env.REACT_APP_API_URL + config.getSegment, payload)
            .then(resp => {
                if (resp.data.success) {
                    let segments=resp.data.success.segment?.length > 0 ? (resp.data.success.segment).split(',').map(Number) : []
                    setDocumentInPrData(resp?.data?.success?.documentList)
                    if(segments.length <= 2){
                        setUploadedInPrData(resp?.data?.success?.documentList)
                    }
                    setSegmentsSelected(segments)
                    setLoading(false)
                }
                else {
                    setLoading(false)
                    throw new Error(resp.data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                console.log(err.message)
            })
    }

    function toogleInnerDialog() {
        setOpenInnerDialog(!openInnerDialog);
    }
    
    const getDocumentTypeOptions = (documentTypeCode, documentUploadedForValue, id, docMidValue) => {
        if (documentTypeCode == "Photo") {
            getLocationDetails()
            setDocMId(33)
        }
        if (documentTypeCode == "IPV") {
            toggleIPVPopup()
            setDocMId(35)
        }
        else {
            setOpenInnerDialog(!openInnerDialog)
        }
        setDocumentTypeOption(documentTypeCode)
        setDocumentUploadedFor(documentUploadedForValue)
        setDocumentMasterId(id)
    }

    const handleSegmentChange = (event, newValues) => {
        let val=event.target.value
        if (val !== null) {
            if (newValues.indexOf(val) !== -1) {
                newValues = newValues.filter(item => item != val && item !== 1 && item !== 2);
            } else {
                newValues.push(val);
            }
            setSegmentsSelected(removeDuplicates(newValues));
            updateSegmentsSelected(removeDuplicates(newValues))
        }
    };

    const updateSegmentsSelected = (data) =>{
        setLoading(true)
        let payload = {
            "segment":data.join(",")
        }
        axios.post(process.env.REACT_APP_API_URL + config.uploadSegment, payload)
            .then(resp => {
                if (resp.data.success) {
                    getSegmentsSelected()
                }
                else {
                    throw new Error(resp.data.error)
                }
            })
            .catch(err => {
                console.log(err.message)
            })
    } 

    function removeDuplicates(arr) {
        let updatedArr=[]
       for(let i=0; i<arr.length; i++){
        if(typeof arr[i] !== "string" ){
            updatedArr.push(arr[i])
        }
       }
       updatedArr=updatedArr.sort()
       return updatedArr
    }

    const displayData = (index) => {
        value=segmentsSelected
        if (index == 2 ) {
            setIndexValue(2)
        } else {
            setIndexValue(index)
        }
    }

    const getLocationDetails = () => {
        if (!navigator.geolocation) {
            setResponseStatus({ "message": localeText?.UploadGeolocation, "type": "warning" })
            setSnackBarOpen(true)
            console.log("Geolocation is not supported by your browser")
        }
        else {
            navigator.geolocation.getCurrentPosition((position) => {
                let positionData = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                }
                setGeoLocationData(positionData)
            },
                function showError(error) {
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            setResponseStatus({ "message": localeText?.UploadsGrant, "type": "warning" })
                            setSnackBarOpen(true)
                            console.log("User denied the request for Geolocation.")
                            break;
                        case error.POSITION_UNAVAILABLE:
                            setResponseStatus({ "message": localeText?.UploadsGeolocation, "type": "warning" })
                            setSnackBarOpen(true)
                            console.log("Geolocation is not supported by your browser.")
                            break;
                        case error.TIMEOUT:
                            setResponseStatus({ "message": localeText?.UploadsTimeOut, "type": "warning" })
                            setSnackBarOpen(true)
                            console.log("The request to get user location timed out.")
                            break;
                        case error.UNKNOWN_ERROR:
                            setResponseStatus({ "message": localeText?.UploadserrorOccurred, "type": "error" })
                            setSnackBarOpen(true)
                            console.log("An unknown error occurred.")
                            break;
                    }
                }
            )
        }
    }

    const onFile = (prm, docId, count, name, mappingKey) => {
        prm.then(succ => {
            toogleInnerDialog()
            if (succ.type.includes("pdf")) {
                setPdf(succ)
                setPdfPopup(true)
            }
            else {
                setImage([succ.data])
                setUploadPopup(true)
            }
            setDocMId(docId)
            setNumberOfImages(count)
            setDocumentName(name)
            setDocumentMappingKey(mappingKey)
        })
    }

    const onFileNew=(prm,docId,count,name,img,lat,long)=>{
        console.log(lat,long)
        // setLat(lat)
        // setLong(long)
        if(img){
            toogleInnerDialog()
            setImage([img])
            setUploadPopup(true)
            // list.forEach((dat, index) => {
            //     if(dat.id === activeId) {
            //         list[index]['documentName'] = name
            //         list[index]['imageCount'] = count
            //     }
            // })
            // setList([...list])
            setDocMId(docId)
            setNumberOfImages(count)
            setDocumentName(name)
        }
        if(prm){
            prm.then(succ => {
                toogleInnerDialog()
                if (succ.type.includes("pdf")) {
                    setPdf(succ)
                    setPdfPopup(true)
                }
                else {
                    setImage([succ.data])
                    setUploadPopup(true)
                }
                setDocMId(docId)
                setNumberOfImages(count)
                setDocumentName(name)
                // setDocumentMappingKey(mappingKey)
            })}
    }

    const uploadDocument = (documentData) => {
        setLoading(true)
        let documentArr = [...documentsUploadedDetails];
        let count = 0;
        documentData.forEach(document => {
            axios.post(`${process.env.REACT_APP_API_URL}${config.uploadDocument}`, document)
                .then(response => {
                    count++;
                    setLoading(false)
                    if (response.data.success) {
                        var docNotUploaded = response.data.success.find(docResponse => docResponse.Status == false)

                        if (docNotUploaded) {
                            setResponseStatus({ "message": `${localeText?.UploadsUnable}${docNotUploaded.uploadId}`, "type": "error" })
                            setSnackBarOpen(true)
                        }
                        else {
                            setResponseStatus({ "message": localeText?.UploadesSuccessfully, "type": "success" })
                            setSnackBarOpen(true)
                            documentArr = [...documentArr, {
                                "documentTypeCode": document.docTypeCode,
                                "proofId": response.data.success[0].id,
                            }]
                            count == documentData.length && setDocumentsUploadedDetails(documentArr)
                        }
                    }
                    if (response.data.error) {
                        setResponseStatus({ "message": response.data.error, "type": "error" })
                        setSnackBarOpen(true)
                    }
                })
                .catch(exception => {
                    setLoading(false)
                    setResponseStatus({ "message": exception.message, "type": "error" })
                    setSnackBarOpen(true)
                })
        })
    }

    const uploadImageProof = (data) => {
        if (data && data.length > 0) {
            var outData = data.map((dt, i) => dt && ({
                "pageNo": (i + 1),
                "uploadId": (i + 1),
                "docTypeCode": documentTypeOption,
                "docMId": docMId,
                "type": documentUploadedFor,
                "latitude": documentTypeOption == "Photo" ? geoLocationData.latitude : "56655",
                "longitude": documentTypeOption == "Photo" ? geoLocationData.longitude : "485454",
                "objectionId": "",
                "fileType": dt.split(",")[0].split("/")[1].split(";")[0],
                "product": "diy",
                "base64Format": dt.split(",")[1],
                "isOcrRequired": process.env.REACT_APP_AINxt == "false" ? false : true,
                "isReUpload":(getCookie("isEmailMobileVerficationFailed") == true) ? true : false
            }))
            uploadDocument(outData)
        }
        setUploadPopup(false)
    }

    

    const uploadPdfProof = (pdfData, pdfName) => {
        setPdfPopup(false)
        var outData = [{
            "pageNo": "1",
            "uploadId": "1",
            "docTypeCode": documentTypeOption,
            "docMId": docMId,
            "type": documentUploadedFor,
            "latitude": documentTypeOption == "Photo" ? geoLocationData.latitude : "",
            "longitude": documentTypeOption == "Photo" ? geoLocationData.longitude : "",
            "objectionId": "",
            "fileType": "pdf",
            "product": "diy",
            "base64Format": pdfData && pdfData.split(",")[1],
            "isOcrRequired": process.env.REACT_APP_AINxt == "false" ? false : true,
            "isReUpload":(getCookie("isEmailMobileVerficationFailed") == true) ? true : false
        }]
        if (pdfData !== null) {
            uploadDocument(outData)
        }
    }

    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const setInitialDocumentData = (data) => {
        let uploadedStatus = []
        data.forEach(doc => {
            doc.isUploaded && uploadedStatus.push({
                "proofId": doc.kycstgProofId,
                "documentTypeCode": doc.documentTypeCode
            })
        })
        setDocumentsUploadedDetails(uploadedStatus)
    }

    const getDocuments = () => {
        setLoading(true)
        setDocumentData([])
        setDocumentInPrData([])
        axios.get(process.env.REACT_APP_API_URL + config.getDocumentsData)
            .then(resp => {
                if (resp.data.success) {

                    setLoading(false)
                    const InprDocumentData = resp.data.success.documentList.filter(function( obj ) {
                        return obj.documentTypeCode == "InPr";
                      });
                    setDocumentInPrData(InprDocumentData)
                    
                    if(UploadedInPrData?.length <=0){
                        let inprDocs = [];
                        InprDocumentData.forEach((ele) => {
                            if (ele.kycstgProofId?.length > 0) {
                                ele.kycstgProofId.forEach(proofId => {
                                    inprDocs.push({
                                        kycstgProofId: proofId,
                                        documentTypeCode: ele.documentTypeCode,
                                        documentSubType: 'holder1',
                                        documentId: ele.id,
                                        isOptional: ele.isOptional,
                                        isUploaded: ele.isUploaded,
                                        documentNumber: ele?.documentNumber
                                    })
                                })
                            }
                        })
                        setUploadedInPrData(inprDocs)
                    }

                    const documentToBeUsed =  resp.data.success.documentList.filter(function( obj ) {
                        return obj.documentTypeCode != "InPr";
                      });
                    setDocumentData(documentToBeUsed)
                    setInitialDocumentData(documentToBeUsed)
                    let docs = [];
                    documentToBeUsed.forEach((ele) => {
                        if (ele.kycstgProofId?.length > 0) {
                            ele.kycstgProofId.forEach(proofId => {
                                docs.push({
                                    kycstgProofId: proofId,
                                    documentTypeCode: ele.documentTypeCode,
                                    documentSubType: 'holder1',
                                    documentId: ele.id,
                                    isOptional: ele.isOptional,
                                    documentNumber: ele?.documentNumber
                                })
                            })
                        }
                    })
                    setUploadedDocuments(docs)
                    
                   /*  let docData = resp.data.success.documentList.filter(doc => doc.kycstgProofId && doc.kycstgProofId[0]).map((doc) => { return { [doc.documentTypeCode]: { kycstgProofId: doc.kycstgProofId, documentTypeCode: doc.documentTypeCode, documentSubType: 'holder1', documentId: doc.id } } })
                    var newObj = Object.assign([], ...docData);

                    setUploadedDocuments(newObj) */
                }
                else {
                    throw new Error(resp.data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                console.log(err.message)
            })
    }

    const nextNavigation = () => {
        if (objectionState.isObjection) {
            objectionNavigation(navigate)
        }
        else {
            dispatch(updateStepper({ step: 4, nestedStep: 1 }));
            navigate("/Review")
        }
    }


    const checkAllMandatoryDocumentsUploaded = (documentData, filteredDocs) => {
        let areDocsUploaded = documentData?.length > 0
        documentData?.filter(doc => !doc.isOptional && !doc.isUploaded).forEach(doc => {
            if (!(filteredDocs?.find(uploadedDoc => uploadedDoc.documentTypeCode == doc.documentTypeCode))) {
                areDocsUploaded = false
            }
        })
        return areDocsUploaded;
    }

    const allDocumentUpdated = () =>{
        var isDocUploaded = true
        documentData?.filter(doc => !doc.isOptional && !doc.isUploaded).forEach(doc => {
            isDocUploaded = false
        })
        if (isDocUploaded && (segmentsSelected.includes(3) || segmentsSelected.includes(4) || segmentsSelected.includes(5))){
            if(!(UploadedInPrData.find(document => document.documentTypeCode == 'InPr')?.kycstgProofId)){
                isDocUploaded = false
            }
        }
        return isDocUploaded;
    }

    const getFilteredDocs = (id, documentData) =>{
        let filteredUploadedDocs = uploadedDocuments?.filter(item =>item.documentTypeCode !== id)
        setUploadedDocuments(filteredUploadedDocs)
        checkAllMandatoryDocumentsUploaded(documentData,filteredUploadedDocs)
    }

    const getFilteredDocsInPrData = (id, documentData) =>{
        //setUploadedInPrData(documentData)
        allDocumentUpdated()
    }

    const toggleIPVPopup = () => {
        setOpenIPVPopup(!openIPVPopup)
    }

    const togglePhotograpghPopup = () => {
        setOpenPhotographPopup(!openPhotographPopup)
    }
    
    return (
        <>
            <PageLayout css={{ overflowY: "scroll" }} showSidebar isObjectionScreen={objectionState.isObjection}
                breadcrumb={{ show: true, steps: steps[3].nestedSteps, step: 4, nestedStep: 1 }}>
                <ElevatedGrid >
                    <Grid container item alignItems={"start"} spacing={2}>
                        <Grid container item alignItems={"center"}>
                            {objectionState.isObjection && <Grid item xs={12} css={{ padding: "10px", color: "white", backgroundColor: "lightcoral", borderRadius: "10px", margin: "10px 0px" }}>
                                {objectionState.objections.map((objection, i) =>
                                    <>
                                        <Typography align="center" display="inline" variant="body2" fontWeight={"bold"}>
                                            {localeText?.profileObjection} {objection.objectionDescription || "--"} {localeText?.profileObjectionRemark} {objection.remark || "--"} <br />
                                        </Typography>
                                        {i > 0 && <Divider />}
                                    </>
                                )}
                            </Grid>}
                            <Grid item alignItems={"center"}>
                                <Typography fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                    {localeText?.UploadesSegments}
                                </Typography>
                            </Grid>
                            <Grid container item xs={12} spacing={2} css={{ marginTop: "5px" }}>
                                    <Grid item xs={12} css={{ textTransform: "none", textAlign: isSmallScreen ? "center" : "none" }}>
                                        <FormControl /* error={formik.touched.segments && Boolean(formik.errors.segments)} */ >
                                            <ToggleButtonGroup
                                                orientation={isSmallScreen ? "vertical" : "horizontal"}
                                                value={segmentsSelected}
                                                id="segments"
                                                // disabled={disableAllFields}
                                                name="segments"
                                                onChange={(e, value) => {
                                                    if (value && value.includes(1) && value.includes(2)) {
                                                        handleSegmentChange(e, value)
                                                    }
                                                }}
                                                color="primary"
                                            >
                                                {segmentOptions.sort((a, b) => a.id - b.id).map((segment, index) =>
                                                    <ToggleButton value={segment.id} onClick={() => displayData(index)}>
                                                        {segment.segmentDescription}
                                                    </ToggleButton>
                                                )}
                                            </ToggleButtonGroup>
                                            {
                                                segmentsSelected?.length == 0 &&
                                                <FormHelperText sx={{color:"#f44336"}}>Segment selection is required</FormHelperText>
                                            }
                                        </FormControl>
                                        {indexValue !== 2 && !(value).includes(3) ?
                                               <Grid item xs={12}>
                                               <Typography display={"inline"} variant='body2' css={{ fontWeight: "bold" }}>
                                                    {localeText?.kycVerificationNote}
                                                </Typography>
                                                <Typography display={"inline"} variant='body2'>
                                                    {<i>{localeText?.kycVerificationNoteText}</i>}
                                                </Typography>
                                        </Grid>
                                        :
                                        <Grid item xs={12}>
                                            <Typography display={"inline"} variant='body2' css={{ fontWeight: "bold" }}>
                                                {localeText?.kycVerificationNote}
                                            </Typography>
                                            <Typography display={"inline"} variant='body2'>
                                                {<i>{localeText?.kycVerificationNoteText}</i>}
                                            </Typography>
                                            <Typography  marginTop="10px" variant='body2' color="primary" css={{ fontWeight: "bolder"}}>
                                                {localeText?.fnoDetailHeader}
                                            </Typography>
                                            <Typography display={"inline"} variant='body2'>
                                                    <li>{localeText?.fnoDetailPoint1}</li>
                                                    <li>{localeText?.fnoDetailPoint2}</li>
                                                    <li>{localeText?.fnoDetailPoint3}</li>
                                                    <li>{localeText?.fnoDetailPoint4}</li>
                                            </Typography>
                                            <Typography variant='body2' color="primary">
                                            <a href="https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html" target="_blank" style={{color:"#24b7cc" , marginLeft:"20px"}}>Tap To Know More </a>
                                            </Typography>
                                        </Grid> 
                                        }
                                    </Grid>
                            </Grid>
                            <Grid item xs={12} sx={{marginBottom:'10px'}}>
                            {
                                (segmentsSelected.includes(3) || segmentsSelected.includes(4) || segmentsSelected.includes(5) && (documentInPrData && UploadedInPrData)) &&
                                <Upload
                                    masterId={documentInPrData.find(document => document.documentTypeCode == 'InPr')?.id}
                                    title={localeText?.UploadIncome}
                                    documentOptionData={{ id: "InPr", type: "holder1", code: "InPr", screen: "" }}
                                    setUploadedDocuments={(data) => setUploadedInPrData(data)}
                                    uploadedDocuments={UploadedInPrData.filter(doc => doc.documentTypeCode == 'InPr')}
                                    isRequired={true}
                                    accountOpeningType={stageDetailsResp?.accountOpeningType}
                                />
                            }
                            </Grid>
                            <Grid item alignItems={"center"}>
                                <Typography fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                    {localeText?.Uploades}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={3}>
                            {documentData?.map((document,i) =>
                                {
                                    if(document?.documentTypeCode != "InPr"){
                                        return <Grid item xs={12}>
                                            <Upload
                                                key={i}
                                                masterId={document.id}
                                                typeCode={document?.documentTypeCode}
                                                title={document.documentTypeName}
                                                documentOptionData={{ id: document.documentTypeCode, type: document.documentTypeCode=='BaPr'? "bank1":"holder1", code: document.documentTypeCode, screen: "" }}
                                                setUploadedDocuments={(data) => setUploadedDocuments([...uploadedDocuments, ...data])}
                                                uploadedDocuments={uploadedDocuments.filter(ele => ele.documentTypeCode == document.documentTypeCode)}
                                                getDocuments={getDocuments}
                                                isRequired={!document.isOptional}
                                                documentData={documentData}
                                                setDocumentData={setDocumentData}
                                                getFilteredDocs={getFilteredDocs}
                                                setOcrUploadLoading={setOcrUploadLoading}
                                                ocrUploadLoading={ocrUploadLoading}
                                                limitPdfPages={(document?.documentTypeCode === "CPOA" || document?.documentTypeCode === "PPOA") ? 1 : false}
                                                ipvPhoto={ipvPhoto}
                                                setIpvPhoto={setIpvPhoto}
                                                stageDetailsResp={stageDetailsResp}
                                                isUploaded = {document?.isUploaded}
                                                docId={document?.kycstgProofId?.length > 0 && document?.kycstgProofId[0]}
                                                uploadScreen={true}
                                            />
                                        </Grid>
                                    }
                                }
                            )}
                        </Grid>
                        <Grid item xs={4} md={1} css={{ marginTop: "40px" }} >
                            <Button variant='contained' color="primary" css={{ width: "100%" }} disabled={!allDocumentUpdated()} onClick={nextNavigation}>
                                {localeText?.planDetailsNextBtn}
                            </Button>
                        </Grid>
                    </Grid>
                </ElevatedGrid>
            </PageLayout>
            {loading && <FullScreenLoader />}

            {/* {documentTypeOption && <PhotoProofDialog setId={setId} onFile={onFile} onFileNew={onFileNew} getDocumentTypeURL={config.documentMaster + documentMasterId} open={openInnerDialog} dialogTitle={documentTypePerName[documentTypeOption]}
                handleClose={toogleInnerDialog} data={documentTypeOption} />} */}
            {showUploadPopup &&<DialogForUpload
                        handleClose={() => { setUploadPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                        title={documentName}
                        imageArray={image ? image : null}
                        count={numberOfImages}  /// gives count to images to upload
                        onSave={(data) => { uploadImageProof(data); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                    />
                }
            {showPdfPopup &&
                <DialogForUpload open={showPdfPopup} handleClose={() => { setPdfPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }} {...props} fullWidth={false} maxWidth='md'>
                    <UploadPdf
                        title={"Upload Pdf"}
                        file={pdf.data}
                        pdfName={pdf.name}
                        handleClose={() => { setPdfPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                        onUpload={(pdfData, pdfName) => { uploadPdfProof(pdfData, pdfName); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                    />
                </DialogForUpload>}

            {/* <Popup
                open={openIPVPopup}
                maxWidth={"md"}
            // fullScreen
            >
                <PopupTitle onClose={toggleIPVPopup} />
                <DialogContent css={{ margin: "0px 30px" }}>
                    <UploadVideo toggleIPVPopup={toggleIPVPopup} uploadVideoProof={uploadVideoProof} matches={isSmallScreen}/>
                </DialogContent>
            </Popup> */}

            <Popup
                open={openPhotographPopup}
                maxWidth={"md"}
            // fullScreen
            >
                <PopupTitle onClose={togglePhotograpghPopup} />
                <DialogContent css={{ margin: "0px 30px" }}>
                    <Grid container alignItems="center" justifyContent="center">
                        <Grid item xs={12}>
                            <Typography variant='body1'>
                               {localeText?.UploadesSEBIRegulations} ( <img css={{ verticalAlign: "middle" }} src="/images/icon_location.svg" /> {localeText?.UploadesOk} <img css={{ verticalAlign: "middle" }} src="/images/icon_my-location.svg" /> )
                                {localeText?.UploadesUrlBrowser}
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Popup>

            {
                responseStatus && responseStatus.message && <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackBarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={handleSnackBarClose}
                        variant={responseStatus.type}
                        message={responseStatus.message}
                    />
                </Snackbar>
            }
        </>
    );
}

export default Uploads;